var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 13.9904C12.7143 13.4968 13.0197 13.0629 13.4252 12.771C14.3824 12.0819 15 10.9947 15 9.77154C15 7.68857 13.2091 6 11 6C8.79086 6 7 7.68857 7 9.77154C7 10.9947 7.61757 12.0819 8.57476 12.771C8.98026 13.0629 9.28571 13.4968 9.28571 13.9904C9.28571 14.3385 9.57317 14.6207 9.92776 14.6207H12.0722C12.4268 14.6207 12.7143 14.3385 12.7143 13.9904Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15736 16.3131C9.15736 15.9338 9.47066 15.6262 9.85713 15.6262H12.1429C12.5293 15.6262 12.8426 15.9338 12.8426 16.3131C12.8426 16.6925 12.5293 17 12.1429 17H9.85713C9.47066 17 9.15736 16.6925 9.15736 16.3131Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.25C5.61522 1.25 1.25 5.61522 1.25 11C1.25 16.3848 5.61522 20.75 11 20.75C13.4221 20.75 15.639 19.866 17.3436 18.4043L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L18.4043 17.3436C19.866 15.639 20.75 13.4221 20.75 11C20.75 5.61522 16.3848 1.25 11 1.25ZM2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 13.2784 18.3274 15.3399 16.8336 16.8336C15.3399 18.3274 13.2784 19.25 11 19.25C6.44365 19.25 2.75 15.5563 2.75 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaSearch);
export default __webpack_public_path__ + "static/media/idea-search.215605d301792f13efbd37f5778e6df1.svg";
export { ForwardRef as ReactComponent };